import React from 'react';
import { api } from '../services/api';
import { PATH_SEGMENTS } from '../config/paths';
import { MomentCategoryItem } from '../types/api';
import AutoCompleteDropdown from './AutoCompleteDropdown';

interface MomentCategoryDropdownProps {
  value: number;
  onChange: (categoryId: number, categoryName: string) => void;
  disabled?: boolean;
  error?: string[];
  emptyMessage?: string;
}

const MomentCategoryDropdown: React.FC<MomentCategoryDropdownProps> = ({
  value,
  onChange,
  disabled = false,
  error,
  emptyMessage
}) => {
  return (
    <AutoCompleteDropdown<MomentCategoryItem>
      apiEndpoint={api(PATH_SEGMENTS.MOMENT, PATH_SEGMENTS.CATEGORY) + '/'}
      itemsKey="mmt_categories"
      value={value}
      onChange={onChange}
      disabled={disabled}
      error={error}
      placeholder="Search moment categories..."
      emptyMessage={emptyMessage}
      className="moment-category-dropdown"
    />
  );
};

export default MomentCategoryDropdown;
